// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"8956856c","406":"1e6896b3"}[chunkId] + ".chunk.css";
};